import { formValidatorStyle } from "../theme/default";

export default function ValidatorSpan({ message }: { message?: string }) {
	return (
		<span style={formValidatorStyle} className="text-danger">
			{message}
		</span>
	);
}
